import base from '../base.js'

export default {
  ...base,
  authBySession: true,
  code: 'r7cb4846',
}
